import type { LlmMessage } from "../../services/llm";
import type {
  EvolutionPreset,
  EvolutionPromptKind,
  EvolutionRule,
} from "./types";
export type EvolutionPlaceholders = Record<string, string>;
function applies(rule: EvolutionRule, kind: EvolutionPromptKind) {
  return (
    rule.enabled &&
    (!rule.promptKindScope || rule.promptKindScope.includes(kind))
  );
}
function render(
  content: string,
  values: EvolutionPlaceholders,
  templates: Record<string, string>,
  depth = 0,
): string {
  if (depth > 8) throw new Error("重点演化模板引用层级过深");
  const expanded = content.replace(
    /\{\{template:([^}]+)\}\}/g,
    (_m, key: string) => {
      const template = templates[key.trim()];
      if (template === undefined)
        throw new Error(`重点演化缺少模板：${key.trim()}`);
      return render(template, values, templates, depth + 1);
    },
  );
  return expanded.replace(
    /\$\{([^}]+)\}/g,
    (_m, key: string) => values[key.trim()] ?? "",
  );
}
function materialize(
  rules: EvolutionRule[],
  kind: EvolutionPromptKind,
  values: EvolutionPlaceholders,
  templates: Record<string, string>,
) {
  return rules
    .filter((rule) => applies(rule, kind))
    .map(
      (rule) =>
        ({
          role: rule.role,
          content: render(rule.content, values, templates),
        }) satisfies LlmMessage,
    )
    .filter((message) => message.content.trim());
}
export function assembleEvolutionMessages(
  preset: EvolutionPreset,
  kind: EvolutionPromptKind,
  values: EvolutionPlaceholders,
): { messages: LlmMessage[]; assistantPrefill: string } {
  const group = preset.prompts[kind];
  if (!group?.enabled) throw new Error(`演化阶段 ${kind} 未启用`);
  const shared =
      kind === "entry_all_focus"
        ? preset.entrySharedRules
        : kind === "item_management"
          ? [...preset.sharedRules, ...(preset.itemSharedRules ?? [])]
          : preset.sharedRules,
    templates = preset.contentTemplates ?? {};
  return {
    messages: [
      ...materialize(shared, kind, values, templates),
      ...materialize(group.rules, kind, values, templates),
    ],
    assistantPrefill: render(group.assistantPrefill ?? "", values, templates),
  };
}
